const { get } = require('@ebay/str-ui-utils/retriever');
const { getTracking } = require('@ebay/str-ui-utils/tracking-util');
module.exports = class {
    onCreate(input) {
        const tracking = get(input, 'model.navigationButton.action.tracking', null);
        const trackingAttr = getTracking(tracking);
        this.state = {
            trackingAttr
        };
    }

    handleClick(cta) {
        const { action: { params: { feature } } } = cta;
        this.emit('announcement-close', {
            feature,
            trackingAttr: this.state.trackingAttr
        });
    }
};
